export const USE_MOCK = false;
